import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/lib/motion";

export default function Sectors() {
  const { t } = useLang();
  return (
    <section id="sectors" data-testid="sectors-section" className="relative py-28 lg:py-40 bg-[#0d0d0d] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
          <div className="lg:col-span-8">
            <Reveal>
              <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.sectors.overline}</span>
              <h2 className="mt-6 font-display text-4xl md:text-6xl font-medium tracking-tight text-white leading-none">
                {t.sectors.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="border-t border-white/10">
          {t.sectors.list.map((s, i) => (
            <Reveal key={s} delay={i * 0.04}>
              <motion.div
                className="group flex items-center justify-between border-b border-white/10 py-6 md:py-8 cursor-default"
                data-testid={`sector-${i}`}
                whileHover={{ backgroundColor: "rgba(212,175,55,0.04)" }}
              >
                <div className="flex items-baseline gap-6 md:gap-10">
                  <span className="font-accent text-sm text-zinc-600">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display text-3xl md:text-6xl text-zinc-300 group-hover:text-white tracking-tight transition-colors duration-300">
                    {s}
                  </span>
                </div>
                <ArrowUpRight className="text-zinc-700 group-hover:text-[#D4AF37] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" size={30} />
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
